<template>
  <div class="content">
    <bs-abnormal
      v-if="isAbnormal"
      :data="data"
      type="notSupport"
      @abnormal="abnormal"
    />
    <bs-approval
      ref="bsapproval"
      :other-data="apporvalData"
    />
  </div>
</template>
<script>
import bsAbnormal from 'components/business/abnormal/index.vue'
import { bsFileDownLoad } from 'js/api/download/download.js'
import { linkDownLoad } from 'js/api/download/linkDown.js'
import isExistPolicy from 'components/business/approval/request-approval'
import bsApproval from 'components/business/approval/request-approval.vue'

export default {
  components: {
    bsAbnormal,
    bsApproval,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    isDelivery: { // 是否是外链
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAbnormal: true, // 是否显示异常组件，这里用了v-if来切换异常组件，使其更新
      apporvalData: {},
    }
  },
  computed: {
    /**
         * 当前选中文件的信息
         */
    fileData() {
      return this.$store.state.curFileInfo
    },
  },
  watch: {
    /**
             * 监听metadata数据的变化，
             * 从而更新v-if, 继而更新notsupport异常组件中的数据
             */
    data: {
      deep: true,
      handler(val) {
        if (val) {
          this.isAbnormal = false
        }
      },
    },
  },
  methods: {
    startPreview() {
      this.isAbnormal = true
    },
    /**
             * 下载最新版本的文件
             */
    downNewRevFile() {
      // 将当前metadata数据版本设置为空，必须未新对象防止污染旧对象
      const { neid, nsid, path } = this.fileData
      const downData = { ...this.data }
      downData.rev = ''
      const downFile = { isDir: false, content: [downData] }
      // 是否存在审批规则
      isExistPolicy({ neid, nsid, path }, 'download').then(() => {
        bsFileDownLoad(downFile)
      }).catch((error) => {
        if (error.data) {
          if (error.data.length === 0) {
            window.$toast.simpleShow(this.$t('该审批规则没有审批者，请联系管理员'), 'warn')
          } else {
            this.apporvalData = {
              approvalType: 'download',
              approvers: error.data,
              neids: [neid],
              nsid,
              path,
            }
            this.$nextTick(() => {
              // 打开审批申请弹框
              this.$refs.bsapproval.show()
            })
          }
        }
      })
    },
    /**
             * 文件的下载
             */
    downFile() {
      if (Object.keys(this.data).length < 1) {
        // 弹窗提示警告信息
        this.$toast.simpleShow('目标文件禁止此操作', 'warn')
        return
      }
      const shareInfo = {
        isSecurity: (this.data.shareInfo && this.data.shareInfo.isSecurity) || false, // 安全外链
        isApprove: (this.data.shareInfo && this.data.shareInfo.isApprove) || false, // 审批外链
        isTrial: this.data.is_trial || false, // 体验用户
      }
      // 下载数据
      linkDownLoad(shareInfo, this.$store.state.curFileInfo, [this.data])
    },
    /**
             * 异常函数的操作事件
             */
    abnormal(key) {
      const cfg = {
        download: this.isDelivery ? 'downFile' : 'downNewRevFile', // download
      }
      if (cfg[key]) {
        this[cfg[key]]()
      }
    },
  },
}
</script>
<style lang="less">
.content {
  display: inline;
}
</style>
